import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./style/style.css";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";

const metaManager = createMetaManager();
createApp(App).use(router).use(metaPlugin).use(metaManager).mount("#app");
